var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.dataLoading,
          expression: "dataLoading",
        },
      ],
      staticStyle: {
        width: "100%",
        height: "100vh",
        "background-color": "#f7f8fa",
      },
      attrs: {
        "element-loading-text": _vm.$t("panel.data_loading"),
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(220,220,220,1)",
      },
    },
    [
      _vm.show
        ? _c("Preview", {
            attrs: {
              "component-data": _vm.mainCanvasComponentData,
              "canvas-style-data": _vm.canvasStyleData,
              "panel-info": _vm.panelInfo,
              "user-id": _vm.user,
            },
            on: { "change-load-status": _vm.setLoading },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }